import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CollectionList from './pages/CollectionList';
import CollectionForm from './pages/CollectionForm';
import LiveStream from './pages/LiveStream';
import Videos from './pages/Videos';
import Audios from './pages/Audios';
import QNA from './pages/QNA';
import Readers from './pages/Readers';
import Categories from './pages/Categories';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/collections/:collectionName"
            element={
              <PrivateRoute>
                <CollectionList />
              </PrivateRoute>
            }
          />
          <Route
            path="/collections/:collectionName/:id"
            element={
              <PrivateRoute>
                <CollectionForm />
              </PrivateRoute>
            }
          />
          <Route
            path="/live"
            element={
              <PrivateRoute>
                <LiveStream />
              </PrivateRoute>
            }
          />
          <Route
            path="/videos"
            element={
              <PrivateRoute>
                <Videos />
              </PrivateRoute>
            }
          />
          <Route
            path="/audios"
            element={
              <PrivateRoute>
                <Audios />
              </PrivateRoute>
            }
          />
          <Route
            path="/categories"
            element={
              <PrivateRoute>
                <Categories />
              </PrivateRoute>
            }
          />
          <Route
            path="/readers"
            element={
              <PrivateRoute>
                <Readers />
              </PrivateRoute>
            }
          />
          <Route
            path="/qna"
            element={
              <PrivateRoute>
                <QNA />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
